export default "__VITE_ASSET__f69586cd__"